import { QRCodeAction } from '../enums';

export interface ICode {
  slug: string;
  codeName: string;
  targetUrl: string;
  created: Date;
  modified?: Date;
  icon?: string;
  scans: number;
  appClientId: string;
  // user
  userEmail: string;
  userCountry: string;
  userLocation: string;
  userRole?: string;
  userName?: string;
  // code details
  targetGroup: string;
  communicationPurpose?: string;
  subcategory?: string;
  locationCountry?: string;
  locationSite?: string;
  onlyOnlineUsage: boolean;
  storeComponent?: string[];
  storeDepartment?: string[];
  carrierType: string[];
  carrierSize: string[];
  permissions?: CodePermission[];
  sourceApp?: string;
}

export interface ICreateCode {
  codeName: string;
  targetUrl: string;
  icon?: string;
  // user
  userEmail: string;
  userCountry: string;
  userLocation: string;
  userRole?: string;
  userName?: string;
  // IKEA app
  appClientId: string;
  appName?: string;
  // code details
  targetGroup: string;
  communicationPurpose?: string;
  locationCountry?: string;
  locationSite?: string;
  onlyOnlineUsage: boolean;
  storeComponent?: string[];
  storeDepartment?: string[];
  carrierType?: string[];
  carrierSize?: string[];
  permissions?: CodePermission[];
  sourceApp?: string;
}

export type IUpdateCode = Partial<ICode>;

export interface IGetCodes {
  username?: string;
  location?: {
    country?: string[];
    site?: string[];
  };
  communicationPurpose?: string[];
  subcategory?: string[];
  carrier?: {
    type?: string[];
    size?: string[];
  };
  store?: {
    component?: string[];
    department?: string[];
  };
  appClientId?: string;
}

export interface ICodeEvent {
  userEmail?: string;
  action: QRCodeAction;
  newCode?: ICode;
  oldCode?: ICode;
}

export interface CodePermission {
  type: CodePermissionType;
  value: string;
}

export enum CodePermissionType {
  User = 'user',
  Location = 'location',
}
